export enum AnnouncementLevel {
  Info = 'INFO',
  Warning = 'WARNING',
  Critical = 'CRITICAL',
}

export interface AnnouncementDto {
  id: string;
  level: AnnouncementLevel;
  message: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PublicAnnouncementDto {
  id: string;
  level: AnnouncementLevel;
  message: string;
}

export interface CreateAnnouncementDto {
  level: AnnouncementLevel;
  message: string;
  publish?: boolean;
}

export interface UpdateAnnouncementDto {
  level?: AnnouncementLevel;
  message?: string;
}

export interface AssetAnnouncementDto {
  id: string;
  level: AnnouncementLevel;
  message: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdById: string;
}

export interface CreateAssetAnnouncementDto {
  message: string;
  level?: AnnouncementLevel;
  publish?: boolean;
}

export interface UpdateAssetAnnouncementDto {
  message?: string;
  level?: AnnouncementLevel;
}
